/** 与 `.ig-feed--grid`（minmax(260px, 1fr) + gap 16px）及 `.ig-card` 高度 180px 一致 */

export const IMAGE_GEN_GRID_MIN_COL_PX = 260;
export const IMAGE_GEN_GRID_GAP_PX = 16;
export const IMAGE_GEN_GRID_CARD_HEIGHT_PX = 180;
export const IMAGE_GEN_GRID_ROW_HEIGHT_PX = IMAGE_GEN_GRID_CARD_HEIGHT_PX + IMAGE_GEN_GRID_GAP_PX;

/** 列表视图单条记录估算高度（标题区 + 缩略图行 + gap） */
export const IMAGE_GEN_LIST_ITEM_HEIGHT_PX = 380;
export const IMAGE_GEN_LIST_GAP_PX = 16;

export const IMAGE_GEN_FEED_PAGE_SIZE_MIN = 4;
export const IMAGE_GEN_FEED_PAGE_SIZE_MAX = 80;
export const IMAGE_GEN_FEED_MIN_VISIBLE_ROWS = 2;
/** 首屏多预取半行，减少初次即触发加载 */
export const IMAGE_GEN_FEED_INITIAL_EXTRA_ROWS = 1;
/** 下拉加载时每次追加的行数 */
export const IMAGE_GEN_FEED_LOAD_MORE_ROWS = 2;

export function computeImageGenGridColumnCount(containerWidth: number): number {
  const w = Math.max(containerWidth, IMAGE_GEN_GRID_MIN_COL_PX);
  return Math.max(
    1,
    Math.floor(
      (w + IMAGE_GEN_GRID_GAP_PX) / (IMAGE_GEN_GRID_MIN_COL_PX + IMAGE_GEN_GRID_GAP_PX),
    ),
  );
}

function clampFeedPageSize(size: number): number {
  return Math.min(
    IMAGE_GEN_FEED_PAGE_SIZE_MAX,
    Math.max(IMAGE_GEN_FEED_PAGE_SIZE_MIN, size),
  );
}

function computeFeedRowsForViewport(availableHeight: number, rowHeightPx: number): number {
  const available = Math.max(rowHeightPx, availableHeight);
  return Math.max(
    IMAGE_GEN_FEED_MIN_VISIBLE_ROWS,
    Math.ceil(available / rowHeightPx) + IMAGE_GEN_FEED_INITIAL_EXTRA_ROWS,
  );
}

/** 首屏展示条数（按 grid / list 与容器尺寸估算） */
export function computeImageGenFeedInitialPageSize(options: {
  viewMode: 'grid' | 'list';
  containerWidth: number;
  containerHeight: number;
  reservedTopPx?: number;
}): number {
  const available = Math.max(
    IMAGE_GEN_GRID_ROW_HEIGHT_PX,
    options.containerHeight - (options.reservedTopPx ?? 0),
  );

  if (options.viewMode === 'list') {
    const rows = computeFeedRowsForViewport(
      available,
      IMAGE_GEN_LIST_ITEM_HEIGHT_PX + IMAGE_GEN_LIST_GAP_PX,
    );
    return clampFeedPageSize(rows);
  }

  const cols = computeImageGenGridColumnCount(options.containerWidth);
  const rows = computeFeedRowsForViewport(available, IMAGE_GEN_GRID_ROW_HEIGHT_PX);
  return clampFeedPageSize(cols * rows);
}

/** 下拉加载每批条数 */
export function computeImageGenFeedLoadMorePageSize(
  viewMode: 'grid' | 'list',
  containerWidth: number,
): number {
  if (viewMode === 'list') {
    return clampFeedPageSize(IMAGE_GEN_FEED_LOAD_MORE_ROWS);
  }
  const cols = computeImageGenGridColumnCount(containerWidth);
  return clampFeedPageSize(cols * IMAGE_GEN_FEED_LOAD_MORE_ROWS);
}
